export const scrubDataId = (dataId) => {
    return dataId
        .toLowerCase()
        .replaceAll(' ', '-') // remove blank spaces
        .replaceAll(/--+/g, '-'); // remove multiple dashes
};
//# sourceMappingURL=scrub_data_id.js.map